<!--
 * @Author: your name
 * @Date: 2019-10-24 20:32:55
 * @Description: In User Settings Edit
 -->
<template>
  <div>
    <el-dialog
      lock-scroll
      :modal-append-to-body="false"
      :append-to-body="true"
      :title="$lang('编辑订单')"
      custom-class="j-dialog"
      :close-on-click-modal="false"
      top="45px"
      :visible.sync="visible"
      @close="close"
      width="960px"
    >
      <div class="overflow">
        <el-form class="el-form-edit" ref="orderForm" :rules="rules" :inline="true" :model="formData" label-position="left" label-suffix=" :">
          <!-- <div class="group-title" style="padding:0 0 16px 0;" v-show="comeFrom==='order'">
            <span class="title">寄件人信息</span>
          </div> -->
          <h3 v-show="comeFrom === 'order'">寄件人信息</h3>
          <div class="group-content" v-show="comeFrom === 'order'">
            <el-form-item :label="$lang('姓名')" prop="senderName">
              <el-input
                v-model="formData.senderName"
                :placeholder="$lang('请输入')"
                :minlength="1"
                :maxlength="30"
                @blur="formData.senderName = $event.target.value.trim()"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$lang('联系电话')" prop="senderMobilePhone">
              <el-input v-model="formData.senderMobilePhone" :placeholder="$lang('请输入')" :maxlength="13"></el-input>
            </el-form-item>
            <el-form-item class="el-form-item el-form-item--small" :label="$lang('邮编')" prop="senderPostalCode">
              <el-input v-model="formData.senderPostalCode" :placeholder="$lang('请输入邮编')" :maxlength="5" @input="changeAddress($event, 1)"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('省/市/区')" prop="senderProvince">
              <BaseAddress ref="senderProvinceSearch" :showLevel="3" :initAddressData="sendAddressData" v-model="formData.senderProvince" :isDisabled="true"> </BaseAddress>
            </el-form-item>
            <el-form-item :label="$lang('公司名称')" prop="senderCompany">
              <template slot="label"
                ><span :title="$lang('公司名称')">{{ $lang('公司名称') }}</span></template
              >
              <el-input v-model="formData.senderCompany" :placeholder="$lang('请输入公司名称')" :minlength="1" :maxlength="100" />
            </el-form-item>
            <el-form-item class="el-form-item item-col-3 el-form-item--small w360" :label="$lang('详细地址')" prop="senderDetailedAddress">
              <el-input v-model="formData.senderDetailedAddress" :placeholder="$lang('请输入')" :minlength="1" :maxlength="201"></el-input>
            </el-form-item>
          </div>
          <!-- <div class="group-title">
            <span class="title">收件人信息</span>
          </div> -->
          <h3>{{ $lang('收件人信息') }}</h3>
          <div class="group-content">
            <el-form-item :label="$lang('姓名')" prop="receiverName">
              <el-input
                v-model="formData.receiverName"
                :placeholder="$lang('请输入')"
                :minlength="1"
                :maxlength="30"
                @blur="formData.receiverName = $event.target.value.trim()"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$lang('联系电话')" prop="receiverMobilePhone">
              <el-input v-model="formData.receiverMobilePhone" :placeholder="$lang('请输入')" :maxlength="13"></el-input>
            </el-form-item>
            <el-form-item class="el-form-item w160 el-form-item--small" :label="$lang('邮编')" prop="receiverPostalCode">
              <el-input v-model="formData.receiverPostalCode" :placeholder="$lang('请输入邮编')" :maxlength="5" @input="changeAddress($event, 2)"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('省/市/区')" prop="receiverProvince">
              <BaseAddress ref="receiverProvinceSearch" :showLevel="3" :initAddressData="receiverAddressData" :isDisabled="true" v-model="formData.receiverProvince"> </BaseAddress>
            </el-form-item>
            <el-form-item :label="$lang('公司名称')" prop="receiverCompany">
              <template slot="label"
                ><span :title="$lang('公司名称')">{{ $lang('公司名称') }}</span></template
              >
              <el-input v-model="formData.receiverCompany" :placeholder="$lang('请输入公司名称')" :minlength="1" :maxlength="100" />
            </el-form-item>
            <el-form-item class="el-form-item item-col-3 el-form-item--small w360" :label="$lang('详细地址')" prop="receiverDetailedAddress">
              <el-input v-model="formData.receiverDetailedAddress" :placeholder="$lang('请输入')" @change="changeReceiverDetailedAddress" :minlength="1" :maxlength="201"></el-input>
            </el-form-item>
          </div>
          <h3>{{ $lang('货物信息') }}</h3>
          <div class="group-content">
            <el-form-item :label="$lang('物品类型')" prop="goods">
              <Base-Select
                v-model="formData.goods"
                @change="getupStairsValue"
                :props="{ label: 'name', value: 'code', res: 'appArticleTypeVOList', valueObj: true }"
                dicUrl="/vip/baseData/list"
                :placeholder="$lang('请选择')"
              ></Base-Select>
            </el-form-item>
            <el-form-item :label="$lang('物品名称')" prop="goodsName">
              <el-input v-model="formData.goodsName" :placeholder="$lang('请输入')" :minlength="1" :maxlength="100"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('物品重量')" prop="packageTotalWeight">
              <el-input-number v-model="formData.packageTotalWeight" @change="getupStairsValue" label="描述文字" :precision="2" :min="0" :max="99999.9"></el-input-number>
            </el-form-item>
            <el-form-item :label="$lang('支付方式')" prop="payment">
<!--              <Base-Select-->
<!--                v-model="formData.payment"-->
<!--                :props="{ label: 'name', value: 'code', res: 'appPaymentMannerVOList', valueObj: true }"-->
<!--                dicUrl="/vip/baseData/list"-->
<!--                :placeholder="$lang('请选择')"-->
<!--              >-->
<!--              </Base-Select>-->
              <Base-Select  v-model="formData.payment"
                            :dic="customerPayments"
                            :placeholder="$lang('请选择')"
                            :props="{label:'name' ,value:'code',valueObj:true}">
              </Base-Select>
            </el-form-item>
            <el-form-item :label="$lang('快递类型')" prop="expressType">
              <Base-Select
                v-model="formData.expressType"
                @change="getupStairsValue"
                :props="{ label: 'name', value: 'code', res: 'appProductTypeVOList', valueObj: true }"
                dicUrl="/vip/baseData/list"
                :placeholder="$lang('请选择')"
              >
              </Base-Select>
            </el-form-item>
            <el-form-item :label="$lang('参考运费')" prop="standardValue" v-show="user.freightStatus === 1">
              <el-input v-model="formData.standardValue" disabled></el-input>
            </el-form-item>
            <el-form-item :label="$lang('客户订单号')" prop="customerOrderId">
              <el-input v-model="formData.customerOrderId" :placeholder="$lang('请输入')" :minlength="1" :maxlength="50"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('是否保价')" prop="insured" class="insured-info">
              <Base-Select
                v-model="formData.insured"
                :clearable="false"
                :dic="DIC.insured"
                :disabled="formData.goodsTypeName === '文件' || formData.paymentModeName === '到付现结' || this.insuranceFlag === 1"
                :placeholder="$lang('请选择')"
                @change="changeInsured"
                :props="{ label: 'name', value: 'code' }"
              ></Base-Select>
              <!--            <a class="btn-insured" @click="openInsured">{{$lang('保价声明')}}</a>-->
            </el-form-item>
            <el-form-item :label="$lang('物品价值')" prop="declaredValue" v-show="formData.insured === 1" class="declaredValue">
              <el-input-number
                v-model="formData.declaredValue"
                @change="calculationPremium"
                :placeholder="$lang('请输入')"
                :step="1"
                :precision="2"
                :controls="false"
                :min="0"
              ></el-input-number>
            </el-form-item>
            <el-form-item :label="$lang('保价费')" prop="insuredValue" v-show="formData.insured === 1" v-show="user.freightStatus === 1">
              <el-input v-model="formData.insuredValue" :placeholder="$lang('请输入')" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item>
              <template>
                <div style="display: block; white-space: nowrap; color: #999; height: 22px; line-height: 16px;">
                  {{$lang('(长*宽*高*件数，cm)')}}:
                  <el-tooltip effect="dark" placement="bottom">
                    <span class="tooltip-click">?</span>
                    <div slot="content">
                      {{ $lang('件数可不输入，件数将依据总件数') }}<br>
                      {{ $lang('输入件数，总件数将会无效') }}
                    </div>
                  </el-tooltip>
                </div>
              </template>
              <el-input type="textarea" :autosize="{ minRows: 1, maxRows: 9999}" v-model="countParams" :placeholder="$lang('例：a*b*c*件数，允许多行，按回车换行')"></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-button type="primary" size="small" style="margin-top: 30px" @click="countWeight">{{ $lang('计算') }}</el-button>
            </el-form-item>
            <el-form-item :label="$lang('总件数')" prop="packageNumber">
              <el-input-number v-model="formData.packageNumber" :step="1" :precision="0" :min="1" :max="999" @change="countWeight"></el-input-number>
            </el-form-item>
            <el-form-item :label="$lang('总体积(m³)')" prop="totalPackageVolume">
              <el-input-number v-model="formData.totalPackageVolume" :min="0.001" :precision="3" :max="99.999" @change="countWeightTotal"></el-input-number>
            </el-form-item>
            <el-form-item :label="$lang('总体积重(kg)')">
              <el-input v-model="formData.packateVolume" disabled :min="0.0" :precision="2" :max="99999.9"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('计费重量(kg)')">
              <el-input v-model="formData.packageChargeWeight" disabled :precision="2" :min="1.0" :max="99999.9"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('是否签回单')" prop="signReceipt">
              <template slot="label">
                <span :title="$lang('是否签回单')">{{ $lang('是否签回单') }}</span></template
              >
              <Base-Select
                :clearable="false"
                v-model="formData.signReceipt"
                :dic="DIC.signReceipt"
                :placeholder="$lang('请选择')"
                @change="changeSignReceipt"
                :props="{ label: 'name', value: 'code' }"
              >
              </Base-Select>
            </el-form-item>
            <el-form-item :label="$lang('回单管理费')" prop="receiptFreight" v-show="formData.signReceipt === 1" v-show="user.freightStatus === 1">
              <el-input v-model="formData.receiptFreight" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('是否上楼')">
              <Base-Select :clearable="false" v-model="formData.isUpstairs" :dic="DIC.insured" :placeholder="$lang('请选择')" :props="{ label: 'name', value: 'code' }">
              </Base-Select>
            </el-form-item>
            <el-form-item :label="$lang('是否电梯')" prop="isElevator" v-if="formData.isUpstairs === 1">
              <Base-Select
                :clearable="false"
                v-model="formData.isElevator"
                :dic="DIC.insured"
                :placeholder="$lang('请选择')"
                @change="getupStairsValue"
                :props="{ label: 'name', value: 'code' }"
              >
              </Base-Select>
            </el-form-item>
            <el-form-item :label="$lang('上楼费')" v-if="formData.isUpstairs === 1" v-show="user.freightStatus === 1">
              <el-input v-model="formData.upStairsValue" :placeholder="$lang('请输入')" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('派送方式')"  >
                <Base-Select :clearable="false"
                  v-model="formData.dispatchCode"
                  :dic="dispatchCodeDic"
                  :placeholder="$lang('请选择')"
                  @change="getDispatchCodeValue"
                  :props="{label:'name' ,value:'code'}">
                  </Base-Select>
                
              </el-form-item>

            <br />
            <el-form-item :label="$lang('备注')" prop="remarks" style="width: 860px">
              <el-input type="textarea" v-model="formData.remarks" :maxlength="50" :label="$lang('描述文字')"></el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="dialog-footer">
        <!-- <el-button @click="close">{{ $lang('取消') }}</el-button> -->
        <el-button type="primary" :loading="keyBtn" @click="submit" class="h40">{{ $lang('保 存') }}</el-button>
      </div>
      <InsuredStatement :infoVisible="infoVisible" @closeInsured="closeInsured"></InsuredStatement>
    </el-dialog>
  </div>
</template>

<script>
import { DIC, RESPONSE_SUCCESS } from '@constants'
import { mapGetters } from 'vuex'
import { RULES, phoneAndMobile, checkAddressFormat, integerWeight, isNullObj, isName } from '@utils/rules'
import { getComCost, getSettlement, getComputationCost, getList, getSysAreaInfo, getupStairsValue, getReceiptFee, queryDispatch, getInsuranceFlag, getCustomerByCode,getServiceType } from '@api/module/customer'
import InsuredStatement from '@components/dialog/InsuredStatement'
import debounce from 'lodash/debounce'

export default {
  name: 'EditOrder',
  components: {
    InsuredStatement,
  },
  props: {
    value: {},
    orderData: {
      type: Object,
      default: function () {
        return {}
      },
    },
    comeFrom: {
      type: String,
      default: function () {
        return 'order'
      },
    },
    disablePayment: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      DIC,
      keyBtn: false,
      data: '',
      visible: false,
      infoVisible: false, // 保价费声明弹窗
      formData: {
        senderName: '', // 寄件人姓名,
        senderMobilePhone: '', // 寄件人手机号,
        senderPostalCode: '', // 寄件人邮编,
        senderProvince: {},
        senderProvinceId: '', // 寄件省份id,
        senderProvinceName: '', // 寄件省份名称,
        senderCityId: '', // 寄件城市id,
        senderCityName: '', // 寄件城市名称,
        senderAreaId: '', // 寄件区域id,
        senderAreaName: '', // 寄件区域名称,
        senderCompany: '', // 寄件人公司
        sendCode: '', // 寄件服务方式code
        sendName: '', // 寄件服务方式name
        receiverPostalCode: '', // 收件邮编,
        senderLocal: '', // 寄件区省/市/区
        senderDetailedAddress: '', // 寄件详细地址,
        receiverName: '', // 收件人姓名,
        receiverMobilePhone: '', // 收件人手机号,
        receiverProvince: {},
        receiverProvinceId: '', // 收件省份id,
        receiverProvinceName: '', // 收件省份名称,
        receiverCityId: '', // 收件城市id,
        receiverCityName: '', // 收件城市名称,
        receiverAreaId: '', // 收件区域id,
        receiverAreaName: '', // 收件区域名称,
        receiverLocal: '', // 收件区省/市/区
        receiverDetailedAddress: '', // 收件详细地址,
        receiverCompany: '', // 收件人公司
        dispatchCode: '', // 派件服务方式code
        dispatchName: '', // 派件服务方式name
        insured: 0, // 是否保价1是，0否,
        declaredValue: '', // 物品价值,
        insuredValue: '', // 保价费,
        goods: '', // 物品类型
        goodsTypeId: '', // 物品类型id,
        goodsTypeCode: '', // 物品类型编码,
        goodsTypeName: '', // 物品类型名称,
        goodsName: '', // 物品名称,
        packageTotalWeight: 0, // 物品重量,
        packageNumber: 1, // 物品件数,
        payment: '', // 支付方式
        paymentModeId: '', // 支付方式id,
        paymentModeCode: '', // 支付方式编码,
        paymentModeName: '', // 支付方式名称,
        expressType: '', // 快递类型
        expressTypeCode: '', // 快递类型code
        expressTypeName: '', // 快递类型name
        codMoney: '', // COD,
        codFee: 0, // COD手续费,
        standardValue: 0, // 参考运费,
        boxStandard: '', // 箱材规格
        boxStandardId: '', // 箱材规格id,
        boxStandardCode: '', // 箱材规格编码,
        boxStandardName: '', // 箱材规格名称,
        boxPrice: 0, // 箱材单价,
        remarks: '', // 备注,
        settlementWeight: 0, // 结算重量
        packageChargeWeight: 1, // 结算重量,
        customerOrderId: '',
        totalPackageVolume: 0, // 总体积
        isUpstairs: 0, // 是否上楼
        upStairsValue: 0, // 上楼费
        isElevator: 0, // 是否电梯,是1 否2
        dispatchCode:'',
        dispatchName:'',
      },
      rules: {},
      sendAddressData: {
        formProps: {
          provinceIdProp: 'provinceId',
          provinceNameProp: 'provinceName',
          cityIdProp: 'cityId',
          cityNameProp: 'cityName',
          areaIdProp: 'areaId',
          areaNameProp: 'areaName',
        },
        defaultData: {},
      },
      receiverAddressData: {
        formProps: {
          provinceIdProp: 'provinceId',
          provinceNameProp: 'provinceName',
          cityIdProp: 'cityId',
          cityNameProp: 'cityName',
          areaIdProp: 'areaId',
          areaNameProp: 'areaName',
        },
        defaultData: {},
      },
      startAddressId: null,
      endAddressId: null,
      countParams: '',
      appProductTypeVOList: [], // 轻抛系数列表
      insuranceFlag: 0,
      customerPayments: [],
      dispatchCodeDic: [],
    }
  },
  watch: {
    comeFrom: {
      handler(val) {
        if (val === 'order') {
          this.rules = {
            senderName: [RULES.requiredTrim, { validator: isName }],
            senderMobilePhone: [RULES.required, RULES.isNum, RULES.lengthTenThirdteen, RULES.checkPhone60],
            senderPostalCode: [RULES.required, RULES.lengthFive],
            receiverPostalCode: [RULES.required, RULES.lengthFive],
            senderProvince: [RULES.requiredSelect, { validator: isNullObj }],
            senderDetailedAddress: [RULES.required, { validator: checkAddressFormat }],
            receiverName: [RULES.required, { validator: isName }],
            receiverMobilePhone: [RULES.required, RULES.isNum, RULES.lengthTenThirdteen, RULES.checkPhone60],
            receiverProvince: [RULES.requiredSelect, { validator: isNullObj }],
            receiverDetailedAddress: [RULES.required, { validator: checkAddressFormat }],
            goods: [RULES.requiredSelect],
            // goodsName: [RULES.required, { validator: checkGoodsName }],
            packageTotalWeight: [RULES.required, { validator: integerWeight }],
            payment: [RULES.requiredSelect],
            insured: [RULES.requiredSelect],
            packageNumber: [RULES.required],
            totalPackageVolume: [RULES.required],
            expressType: [RULES.requiredSelect],
          }
        } else {
          this.rules = {
            receiverName: [RULES.requiredTrim, { validator: isName }],
            receiverMobilePhone: [RULES.requiredTrim, { validator: phoneAndMobile }, RULES.lengthTenThirdteen, RULES.checkPhone60],
            receiverProvince: [RULES.requiredSelect, { validator: isNullObj }],
            receiverDetailedAddress: [RULES.required, { validator: checkAddressFormat }],
            goods: [RULES.requiredSelect],
            packageTotalWeight: [RULES.required, { validator: integerWeight }],
            payment: [RULES.requiredSelect],
            insured: [RULES.requiredSelect],
            packageNumber: [RULES.required],
            totalPackageVolume: [RULES.required],
            expressType: [RULES.requiredSelect],
            isElevator: [RULES.requiredSelect],
          }
        }
      },
      immediate: true,
    },
    value: {
      handler(val) {
        this.visible = val
      },
      immediate: true,
    },
    orderData: {
      handler(val) {
        // 箱材规格 初始化
        const boxStandard = {
          id: val.boxStandardId,
          materialCode: val.boxStandardCode,
          materialName: val.boxStandardName,
          boxPrice: val.boxPrice,
          salesPrice: val.boxPrice,
          name: val.boxStandardName,
          code: val.boxStandardCode,
        }
        const goods = {
          id: val.goodsTypeId,
          code: val.goodsTypeCode,
          name: val.goodsTypeName,
        }
        const payment = {
          id: val.paymentModeId,
          code: val.paymentModeCode,
          name: val.paymentModeName,
        }
        const expressType = {
          code: val.expressTypeCode, // 快递类型code
          name: val.expressTypeName, // 快递类型name
        }
        // this.formData = Object.assign(...val, { boxStandard }, { goods }, { payment }, { expressType })
        this.formData = { ...val, ...{ boxStandard, goods, payment, expressType }}
        this.handleProvice(this.formData)
        // 实时获取是否强制保价
        this.getInsuranceFlag()
        this.countParams = ''
      },
      deep: true,
    },
    // 物品类型
    async 'formData.goods'(val) {
      const { id: goodsTypeId, code: goodsTypeCode, name: goodsTypeName } = val || {}
      Object.assign(this.formData, { goodsTypeId, goodsTypeCode, goodsTypeName })
      const { declaredValue, goods, insured } = this.formData
      if (insured === 1 && goods && parseFloat(declaredValue) > 0) {
        const res = await this.getComputationCost(this.formData)
        Object.assign(this.formData, { insuredValue: res })
      } else {
        this.formData.insuredValue = 0
      }
      if (goodsTypeName === '文件') {
        Object.assign(this.formData, { insured: 0, declaredValue: '' })
        this.formData.insuredValue = 0
      }
    },
    // 支付方式
    async 'formData.payment'(val) {
      const { id: paymentModeId, code: paymentModeCode, name: paymentModeName } = val || {}
      Object.assign(this.formData, { paymentModeId, paymentModeCode, paymentModeName })
      const { senderProvince, receiverProvince, packageTotalWeight } = this.formData
      if (senderProvince && receiverProvince && val && packageTotalWeight > 0) {
        const res = await this.calcStandardCost(this.formData)
        Object.assign(this.formData, res)
      }
      // 到付现结不支持保价
      if (val.name === '到付现结') {
        Object.assign(this.formData, { insured: 0, declaredValue: '' })
        this.formData.insuredValue = 0
      }
    },
    async 'formData.expressType'(val) {
      const { code, name } = val
      Object.assign(this.formData, { expressTypeCode: code, expressTypeName: name })
      // 重新计算轻抛系数
      this.countWeightTotal()
    },
    // 计费重量
    async 'formData.packageChargeWeight'(val) {
      const { senderProvince, receiverProvince } = this.formData
      if (senderProvince && receiverProvince && val > 0) {
        const res = await this.calcStandardCost(this.formData)
        Object.assign(this.formData, res)
      }
    },
    // 转换计算长度变化
    async 'formData.packageLength'(val, oldval) {
      if (Number(val) !== Number(oldval)) {
        this.mergeWidthHeightLength()
      }
    },
    // 转换计算宽度变化
    async 'formData.packageWide'(val, oldval) {
      if (Number(val) !== Number(oldval)) {
        this.mergeWidthHeightLength()
      }
    },
    // 转换计算高度变化
    async 'formData.packageHigh'(val, oldval) {
      if (Number(val) !== Number(oldval)) {
        this.mergeWidthHeightLength()
      }
    },
    async 'formData.isUpstairs'(val) {
      if (Number(val) === 0) {
        this.formData.upStairsValue = 0
        this.formData.isElevator = 0
      }
    },
  },
  computed: {
    // 用户信息
    userInfo() {
      return this.$store.state.base.user || {}
    },
    ...mapGetters({
      user: 'user',
    }),
  },
  created() {
    // 获取客户信息
    this.getCustomerByCode()
     // 获取派送方式 
    
    this.getServiceType()
  },
  mounted() {
    this.calcStandardCost(this.formData)
    this.getLightTossCoefficient()
    // this.mergeWidthHeightLength()
  },
  methods: {
   //选择派送方式
   getDispatchCodeValue(val){
        if(val){
          let name=''
          for(let i of this.dispatchCodeDic){
            if(val==i.code){
              name=i.desc
            }
          }
          this.formData.dispatchName=name
            // 计算运费
            this.calcStandardCost(this.formData)
        }
    },
    async getServiceType() {
      let params={
        serviceId:15
      }
      const { data, msg, code } = await getServiceType(params)
      if (code === RESPONSE_SUCCESS) {
        if (data&&data.length>0) {
          debugger
            let tmpArr=[]
            let tmpObj={}
            for(let i of data){
              tmpObj={
                code:i.code,
                label:i.name,
                desc:i.name,
                name:i.name
              }
              tmpArr.push(tmpObj)
            }
            this.dispatchCodeDic=tmpArr
            console.log(this.dispatchCodeDic)
        }
      } else {
        this.$message.error(this.$lang(msg))
      }
    },
    // 获取客户信息
    async getCustomerByCode() {
      const params = {
        code: this.userInfo.customerCode,
      }
      const { code, msg, data } = await getCustomerByCode(params)
      if (code === RESPONSE_SUCCESS) {
        this.customerPayments = [{ code: data.settlementCode, name: this.$lang(data.settlementName) }]
      } else {
        this.$message.error(this.$lang(msg))
      }
    },
    // 实时获取是否强制保价
    async getInsuranceFlag() {
      const params = {
        id: this.userInfo.id,
      }
      const { data, msg, code } = await getInsuranceFlag(params)
      if (code === RESPONSE_SUCCESS) {
        if (data === 1) {
          // 是否保价1是，0否,
          this.insuranceFlag = 1
          this.formData.insured = 1
          this.rules.declaredValue = [RULES.required, RULES.declaredValue]
        } else {
          this.insuranceFlag = 0
          this.rules.declaredValue = []
        }
      } else {
        this.$message.error(this.$lang(msg))
      }
      // this.insuranceFlag = 1
      // this.formData.insured = 1
    },
    // 保价费计算
    async calculationPremium(val) {
      const { goods, insured } = this.formData
      if (insured === 1 && goods && parseFloat(val) > 0) {
        this.keyBtn = true
        const res = await this.getComputationCost(this.formData)
        this.keyBtn = false
        Object.assign(this.formData, { insuredValue: res })
      } else {
        this.formData.insuredValue = 0
      }
    },
    async changeSignReceipt(val) {
      this.keyBtn = true
      if (val === 0) {
        this.formData.receiptFreight = 0
      } else if (val === 1) {
        const params = {
          customerCode: this.userInfo.customerCode,
        }
        const { data, msg, code } = await getReceiptFee(params)
        if (code === RESPONSE_SUCCESS) {
          this.receiptFreight = data
        } else {
          this.$message.error(this.$lang(msg))
        }
        this.formData.receiptFreight = this.receiptFreight
      }
      this.keyBtn = false
    },
    async getupStairsValue() {
      // 获取上楼费
      const { packateVolume } = this.formData
      this.formData.packageChargeWeight = packateVolume > this.formData.packageTotalWeight ? packateVolume : this.formData.packageTotalWeight

      if ((!this.formData.isUpstairs || this.formData.isUpstairs !== 0) && !this.formData.isElevator && this.formData.isElevator !== 0) {
        return
      }
      this.$refs['orderForm'].validate(async (valid) => {
        if (valid) {
          this.keyBtn = true
          const params = {
            costNum: this.formData.packageNumber, // 件数
            costWeight: this.formData.packageChargeWeight, // 计费重量
            goodsCode: this.formData.goods.code, // 物品类型code
            isElevator: this.formData.isElevator, // 是否电梯,是1 否2
            productTypeCode: this.formData.expressType.code, // 产品类型code
          }
          const { code, data, msg } = await getupStairsValue(params)
          if (code === RESPONSE_SUCCESS) {
            this.formData.upStairsValue = data || 0
          } else {
            this.$message.error(msg)
          }
          this.keyBtn = false
        }
      })
    },
    // 通过邮编改变省市区
    async changeAddress(zipCode, type = 1) {
      if (zipCode.length !== 5 && zipCode.length !== 0) return
      const { code, msg, data } = await getSysAreaInfo({ zipCode: zipCode })
      if (code === RESPONSE_SUCCESS) {
        if (type === 2) {
          const { code, data } = await queryDispatch({ zipCode: zipCode})
          if (code !== RESPONSE_SUCCESS || !data || !data.deliverNetworkCode) {
            this.$message.warning(this.$lang('该收件地址邮编未开放'))
          }
        }
        this.codeChangeAddress(data, type)
      } else {
        this.$message.warning(msg)
      }
      this.calcStandardCost(this.formData)
    },
    // 通过邮编改变省市区 ->改变对应值
    async codeChangeAddress(row, type = 1) {
      const { areaId = '', areaName = '', cityId = '', cityName = '', provinceId = '', provinceName = '' } = row || {}
      if (type === 1) {
        const defaultData = {
          provinceId,
          provinceName,
          cityId,
          cityName,
          areaId,
          areaName,
        }
        Object.assign(this.sendAddressData, !row ? { defaultData: {}} : { defaultData })
      } else {
        const defaultData = {
          provinceId,
          provinceName,
          cityId,
          cityName,
          areaId,
          areaName,
        }
        Object.assign(this.receiverAddressData, !row ? { defaultData: {}} : { defaultData })
      }
    },
    // 合并长宽高
    mergeWidthHeightLength: debounce(async function () {
      const { packageLength, packageWide, packageHigh } = this.formData
      if (packageLength || packageWide || packageHigh) {
        this.countParams = `${packageLength}*${packageWide}*${packageHigh}`
        this.countWeight()
      } else {
        this.countParams = ''
      }
    }, 200),
    // 获取轻抛系数
    async getLightTossCoefficient() {
      const { code, data, msg } = await getList()
      if (code === RESPONSE_SUCCESS) {
        if (data.appProductTypeVOList) {
          this.appProductTypeVOList = data.appProductTypeVOList
        }
      } else {
        this.$message.warning(msg)
      }
    },
    // 计算体积
    countWeight() {
      if (!this.countParams) {
        // 没有输入
        this.$message.warning(this.$lang('输入有误，已被忽略求总体积!'))
        return
      }
      const counts = this.countParams.split(/[(\r\n\s)\r\n\s]+/)
      let flag = true
      let packageTotalVolume = 0
      for (let i = 0; i < counts.length; i++) {
        const countList = counts[i].split('*')
        if (countList.length !== 3 && countList.length !== 4) {
          // 输入的乘号不足
          this.$message.warning(this.$lang('输入有误，已被忽略求总体积!'))
          return
        }
        if (!this.formData.packageNumber && countList.length !== 4) {
          // 件数不存在
          this.$message.warning(this.$lang('输入有误，已被忽略求总体积!'))
        }
        let res = 1
        for (let i = 0; i < countList.length; i++) {
          if (isNaN(+countList[i]) || countList[i].match(/^\s*$/)) {
            // 如果存在非数字输入
            this.$message.warning(this.$lang('输入有误，已被忽略求总体积!'))
            flag = false
            break
          } else if (countList[i].length > 5) {
            this.$message.warning(this.$lang('最大值不超过五位数'))
            flag = false
            break
          } else if (countList[i].indexOf('.') > -1) {
            this.$message.warning(this.$lang('不支持小数点'))
            flag = false
            break
          } else {
            res *= Number(countList[i])
          }
        }
        if (flag) {
          // 计算完成
          if (countList.length === 3 && counts.length === 1) {
            res = res * this.formData.packageNumber
          }
          if (res.toFixed(3) > 99999000) {
            this.$message.warning(this.$lang('总体积超额，请重新填写'))
            return
          }
          packageTotalVolume = packageTotalVolume + parseFloat((res / 1000000).toFixed(3))
        }
      }
      if (packageTotalVolume > 0) {
        this.formData.totalPackageVolume = packageTotalVolume
      }
      if (flag) {
        this.countWeightTotal()
        this.getupStairsValue()
      }
    },
    // 轻抛系数计算体积重
    countWeightTotal() {
      const { expressTypeCode, totalPackageVolume, packageTotalWeight } = this.formData
      const list = this.appProductTypeVOList.filter((item) => item.code === expressTypeCode)
      if (list.length > 0 && (totalPackageVolume || totalPackageVolume === 0)) {
        // 体积重=根据总体积/轻抛系数
        const packateVolume = ((totalPackageVolume * 1000000) / list[0].lightThrowingCoefficient).toFixed(2)
        if (packateVolume > 99999.9) {
          this.$message.warning(this.$lang('体积重限额，请重新调整总体积'))
          return
        }
        this.formData.packateVolume = packateVolume
        this.formData.packageChargeWeight = packateVolume > packageTotalWeight ? packateVolume : packageTotalWeight
      }
      // 计算上楼费
      this.getupStairsValue()

      // 计算运费
      this.calcStandardCost(this.formData)
    },
    openInsured() {
      this.infoVisible = true
    },
    closeInsured() {
      this.infoVisible = false
    },
    async changeInsured(val) {
      this.formData.insured = val
      if (val === 0) {
        this.formData.insuredValue = 0
        this.formData.declaredValue = ''
      }
      const { goods, declaredValue } = this.formData
      if (val === 1 && goods && declaredValue && parseFloat(declaredValue)) {
        const res = await this.getComputationCost(this.formData)
        Object.assign(this.formData, { insuredValue: res })
      } else {
        this.formData.insuredValue = 0
      }
    },
    changeBoxStandard(val) {
      if (!val) {
        this.formData.boxPrice = 0
      }
      if (val && val.salesPrice) {
        const { id: boxStandardId, name: boxStandardName, salesPrice: boxPrice } = val
        Object.assign(this.formData, {
          // 箱材规格id
          boxStandardId,
          // 箱材规格名称
          boxStandardName,
          // 箱材单价
          boxPrice,
        })
      }
    },
    async submit() {
      const addrValidate = await this.changeReceiverDetailedAddress(this.formData.receiverDetailedAddress)
      if (addrValidate) {
        return
      }

      const { code, data } = await queryDispatch({ zipCode: this.formData.receiverPostalCode })
      if (code !== RESPONSE_SUCCESS || !data || !data.deliverNetworkCode) {
        this.$message.warning(this.$lang('该收件地址邮编未开放'))
        return
      }
      if (this.formData.paymentModeId === 321 && this.formData.insured !== 0) {
        this.$message.error(this.$lang('到付件不支持保价'))
        return
      }
      if (this.formData.insured === 1 && (!this.formData.declaredValue || parseFloat(this.formData.declaredValue) <= 0)) {
        this.$message.error(this.$lang('物品价值必须大于0'))
        return
      }
      if (this.formData.isUpstairs === 1 && !this.formData.upStairsValue && this.formData.upStairsValue !== 0) {
        this.$message.error(this.$lang('暂不支持上楼服务'))
        return
      }
      if (this.formData.standardValue === 0) {
        this.$message.error(this.$lang('未获取到客户报价'))
        return
      }
      if (!this.formData.dispatchCode ) {
        this.$message.error(this.$lang('派送方式不能为空'))
        return
      }
      if (this.orderData.receiptWaybillNo) {
        this.formData.receiptWaybillNo = this.orderData.receiptWaybillNo
      }
      debugger
      this.$emit('editSave', this.formData)
    },
    close() {
      this.$emit('editClose', false)
    },
    // 运费计算
    calcStandardCost: debounce(async function (data2) {
      const { senderProvince, receiverProvince, packageChargeWeight, paymentModeId } = data2
      const result = {
        // 寄件省份id
        senderProvinceId: senderProvince.provinceId,
        // 寄件省份名称
        senderProvinceName: senderProvince.provinceName,
        // 寄件城市id
        senderCityId: senderProvince.cityId,
        // 寄件城市名称
        senderCityName: senderProvince.cityName,
        // 寄件区域id
        senderAreaId: senderProvince.areaId,
        // 寄件区域名称
        senderAreaName: senderProvince.areaName,
        // 收件省份id
        receiverProvinceId: receiverProvince.provinceId,
        // 收件省份名称
        receiverProvinceName: receiverProvince.provinceName,
        // 收件城市id
        receiverCityId: receiverProvince.cityId,
        // 收件城市名称
        receiverCityName: receiverProvince.cityName,
        // 收件区域id
        receiverAreaId: receiverProvince.areaId,
        // 收件区域名称
        receiverAreaName: receiverProvince.areaName,
      }
      if (this.formData.receiverPostalCode) {
        // 获取十字码
        const { code, data } = await queryDispatch({ zipCode: this.formData.receiverPostalCode })
        if (code !== RESPONSE_SUCCESS || !data || !data.deliverNetworkCode) {
          // this.$message.warning(this.$lang('该收件地址邮编未开放'))
        } else {
          // 派件网点
          this.formData.dispatchNetworkId = data.deliverNetworkId
        }
      }

      // 运费
      const obj = {}
      if (result.senderAreaId && result.receiverAreaId) {
        const promises = [
          // 获取起始地址ID
          this.getSettlement(result.senderProvinceId, result.senderCityId, result.senderAreaId),
          // 获取目的地地址ID
          this.getSettlement(result.receiverProvinceId, result.receiverCityId, result.receiverAreaId),
        ]
        const [startAddressId, endAddressId] = await Promise.all(promises)
        // 如果起始地址且目的地地址ID存在
        if (startAddressId && endAddressId) {
          // 获取运费
          const res = await this.getComCost(packageChargeWeight, startAddressId, endAddressId, paymentModeId,this.formData.dispatchNetworkId)
          obj.standardValue = res.cost
          obj.settlementWeight = res.setWeight
          this.formData.standardValue = res.cost
          this.formData.settlementWeight = res.setWeight
        }
        debugger
      }
      // 返回结果
      return {
        ...result,
        ...obj,
      }
    }, 200),
    // 城市重新赋值
    handleProvice(row) {
      const {
        senderProvinceId = '',
        senderProvinceName = '',
        senderCityId = '',
        senderCityName = '',
        senderAreaId = '',
        senderAreaName = '',
        receiverProvinceId = '',
        receiverProvinceName = '',
        receiverCityId = '',
        receiverCityName = '',
        receiverAreaId = '',
        receiverAreaName = '',
      } = row || {}
      const sendObj = {}
      sendObj.provinceId = senderProvinceId
      sendObj.provinceName = senderProvinceName
      sendObj.cityId = senderCityId
      sendObj.cityName = senderCityName
      sendObj.areaId = senderAreaId
      sendObj.areaName = senderAreaName
      Object.assign(this.sendAddressData, { defaultData: sendObj })
      const receiverObj = {}
      receiverObj.provinceId = receiverProvinceId
      receiverObj.provinceName = receiverProvinceName
      receiverObj.cityId = receiverCityId
      receiverObj.cityName = receiverCityName
      receiverObj.areaId = receiverAreaId
      receiverObj.areaName = receiverAreaName
      Object.assign(this.receiverAddressData, { defaultData: receiverObj })
    },
    // 通过省市区匹配结算目的地(目的区域)
    async getSettlement(providerId, cityId, areaId, packageTotalWeight, type) {
      const reqData = { providerId, cityId, areaId }
      const { code, data } = await getSettlement(reqData)
      if (code === 1 && data) {
        const id = data.id
        return id
      } else {
        return ''
      }
    },
    // 运费计算
    async getComCost(number, startAddressId, endAddressId, paymentModeId, dispatchNetworkId) {
      let smMode = 2
      if (paymentModeId) {
        switch (paymentModeId) {
          case 320:
            smMode = 1
            break
          case 319:
            smMode = 2
            break
          case 321:
            smMode = 3
            break
        }
      }
      const reqData = { startAddressId, endAddressId, number, smMode, dispatchCode: this.formData.dispatchCode, dispatchNetworkId: dispatchNetworkId }
      const { data = 0 } = await getComCost(reqData)
      return data || 0
    },
    // 保价费计算
    async getComputationCost(param) {
      // 参数
      const params = {
        // 物品价值
        value: param.declaredValue,
        // 物品类型code
        goodsTypeCode: param.goods.code,
      }
      // 调用接口
      const { data } = await getComputationCost(params)
      return data || 0
    },
    async changeReceiverDetailedAddress(val) {
      if (val) {
        if (!val.includes(this.formData.receiverPostalCode)) {
          this.$message.error(this.$lang('邮编和详细地址的邮编不匹配'))
          return true
        }
        var numReg = /^[0-9]*$/
        var numRe = new RegExp(numReg)

        var num1 = val.indexOf(this.formData.receiverPostalCode) - 1
        var num2 = val.indexOf(this.formData.receiverPostalCode) + this.formData.receiverPostalCode.length
        if ((val[num1] && numRe.test(val[num1])) || (val[num2] && numRe.test(val[num2]))) {
          this.$message.error(this.$lang('收件信息所输入的邮编与详细地址的邮编不匹配，请确保两个邮编是相同的。'))
          return true
        }
      }
      return false
    },
  },
}
</script>

<style lang="scss" scoped>
.tooltip-click{
  margin-left: 5px;
  width: 18px;
  height: 18px;
  background: #197D3B;
  color: #fff;
  border-radius: 18px;
  text-align: center;
  line-height: 18px;
  display: inline-block;
}

.group-title {
  border-bottom: 1px dashed #eeeeee;
  // margin-bottom: 20px;
  margin: 0 10px 20px 10px;
  padding: 16px 0px;
  .title {
    font-size: 14px;
    color: #333;
    font-weight: 600;
    display: inline-block;
    line-height: 7px;
    border-bottom: 4px solid #e0bd7b;
  }
  .insert-info {
    display: inline-block;
    margin-left: 60px;
    position: relative;
    .icon {
      color: #e0bd7b;
      position: absolute;
      overflow: visible;
    }
    .text {
      color: #666666;
      margin-left: 20px;
    }
  }
}
.el-form-item {
  padding: 0px 8px 18px 8px !important;
}
.group-content {
  background: #f7f7f9;
  padding: 20px 20px 10px;
  border-radius: 8px;
}

.w180 {
  // width: calc(20% + 160px);
  width: 400px !important;
  .el-input {
    width: 360px !important;
  }
}
.w360 .el-input {
  width: 360px !important;
}
</style>
<style lang="scss">
.el-dialog__wrapper .el-dialog.j-dialog {
  margin-bottom: 0 !important;
}
.el-dialog__wrapper .el-dialog.j-dialog .el-dialog__body {
  max-height: 700px;
  overflow: auto;
  padding: 10px 20px;
  .dialog-footer {
    border-top: 0;
    margin-top: 0px;
    margin-bottom: 20px;
  }
}
</style>
<style lang="scss">
.el-form.el-form-edit .el-form-item.insured-info .el-form-item__content {
  position: relative;
  .btn-insured {
    // color: #2D7CFF;
    color: #e60012;
    font-size: 12px;
    cursor: pointer;
    position: absolute;
    right: 24px;
    top: -22px;
    display: inline-block;
    height: 22px;
    line-height: 16px;
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
